import {calculateCover} from './image';
import {effects} from './effects';

const basePath = '/themes/custom/giantrabbit/images';

export class AnimationImage {
  cacheDimensions() {
    this.naturalHeight = this.image.naturalHeight;
    this.naturalWidth = this.image.naturalWidth;
    this.originalHeight = this.image.height;
    this.originalWidth = this.image.width;
    this.height = this.originalHeight;
    this.width = this.originalWidth;
  }
  
  constructor(fileName, container, image = null, classes = []) {
    this.container = container;
    this.fileName = fileName;
    this.image = image;
    this.classes = classes;
  }

  css(styles) {
    this.image.css(styles);
  }

  hide() {
    effects.hide(this.image);
  }

  async load() {
    if (this.image === null) {
      this.image = document.createElement('img');
      this.image.src = this.url();
      if (this.classes.length > 0) {
        this.image.className = this.classes.join(' ');
      }
      this.container.append(this.image);
      return new Promise(this.loadImage.bind(this));
    } else {
      this.cacheDimensions();
    }
    return this;
  }

  loadImage(resolve, reject) {
    if (this.image.complete) {
      this.onLoad(resolve, reject);
    } else {
      this.image.addEventListener('load', this.onLoad.bind(this, resolve, reject));
    }
  }

  onLoad(resolve, reject) {
    this.cacheDimensions();
    resolve(this);
  }

  scaleTo(scaleFactor) {
    this.height = this.naturalHeight * scaleFactor;
    this.width = this.naturalWidth * scaleFactor;
    this.image.style.height = this.height + 'px';
    this.image.style.width = this.width + 'px';
  }

  show() {
    effects.show(this.image);
  }

  url() {
    return basePath + '/' + this.fileName;
  }
}
